import { convertMbToByte } from "@/utils/file";

export const MAX_SIZE = convertMbToByte(10); // 10MB
export const MAX_JOB_DOCUMENT_FILE = 1;
export const MAX_JOB_UPLOAD_FILES = 5;

export const JOB_DOCUMENT_FILE_TYPES_EXTENSION = [
  ".pdf",
  ".doc",
  ".docx",
  ".xls",
  ".xlsx",
  ".csv",
  ".txt",
  ".jpg",
  ".jpeg",
  ".png",
  ".tif",
  ".tiff",
];

export const JOB_DOCUMENT_FILE_MINE_TYPES = [
  "application/pdf", //pdf
  "application/msword", //doc
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document", //doc
  "application/x-ole-storage", //docx
  "application/vnd.ms-excel", //xls
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", //xlsx
  "text/plain", //txt
  "text/csv", //csv
  "image/jpg",
  "image/jpeg",
  "image/png",
  "image/tif",
  "image/tiff",
];

export const JOB_IMAGE_TYPES_EXTENSION = [
  ".jpg",
  ".jpeg",
  ".png",
  ".gif",
  ".tif",
  ".tiff",
];

export const JOB_IMAGE_MINE_TYPES = [
  "image/jpg",
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/tif",
  "image/tiff",
];
